/**
 * Every console image goes through Vite: small SVGs are inlined into the bundle (no request at all) and the rest
 * get content-hashed names under /assets, which the console server caches for a year. Logo and mark are also
 * preloaded from index.html; the mascots are warmed on idle by warmImages().
 */
import logo from "./logo.webp";
import mark from "./mark.webp";
import mascotPresenting from "./mascot/now-cat-presenting.webp";
import mascotSuccess from "./mascot/now-cat-success.webp";

export { logo, mark, mascotPresenting, mascotSuccess };

const byName = (files: Record<string, string>) =>
  Object.fromEntries(Object.entries(files).map(([path, url]) => [path.slice(path.lastIndexOf("/") + 1, -4), url]));

const chains = byName(import.meta.glob<string>("./chains/*.svg", { eager: true, query: "?url", import: "default" }));
const flags = byName(import.meta.glob<string>("./flags/*.svg", { eager: true, query: "?url", import: "default" }));

export const chainLogo = (chain: string) => chains[chain];
export const flagImg = (code: string) => flags[code];

/** Fetch and decode the images not on the first screen, so later pages show them instantly. */
export function warmImages() {
  const run = () => {
    for (const src of [mascotPresenting, mascotSuccess]) {
      const img = new Image();
      img.src = src;
      img.decode?.().catch(() => {});
    }
  };
  if ("requestIdleCallback" in window) window.requestIdleCallback(run, { timeout: 3000 });
  else setTimeout(run, 1500);
}
